module.exports = __webpack_public_path__ + "img/gz.8afc5789.webp";